import React from 'react';
import '../../styles/corpoClinico.css';
import Neurologista from '../../img/Neurologista.jpg'

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={Neurologista} alt="Gustavo" />
            </div>
            <div className="info-container">
              <h3 className="nome">Gustavo Moura de Almeida</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Neurologista, Gustavo Moura de Almeida é neurologista especializado em Neurologia Adulta, com graduação pela Universidade Federal de Santa Maria (UFSM) e Residência Médica em Neurologia pelo Hospital de Clínicas da UFPR. Possui Mestrado em Medicina Interna pelo HC/UFPR e pesquisa focada em doenças desmielinizantes, como esclerose múltipla. Atua no Hospital de Força Aérea do Galeão (HFAG/RJ) e tem experiência em Neurologia, Neuropediatria, Neurointensivismo e Medicina Intensiva. Com diversas publicações nacionais e internacionais, Gustavo também foi premiado por sua atuação acadêmica e de pesquisa."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;